import { FC, useCallback, MouseEventHandler } from 'react';
import { graphql, useFragment } from 'react-relay';
import classNames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';
import { useAppDispatch } from '../reducers/root';
import { trackFormInteraction } from '../helpers/checkoutTracking';
import { openLoginModal } from '../actions/checkoutAuthActions';
import dibsCss from 'dibs-css';
import { CheckoutGuestAccountLoginLink_userExistsMetadata$key } from './__generated__/CheckoutGuestAccountLoginLink_userExistsMetadata.graphql';

type Props = {
    email: string;
    userExistsMetadata: CheckoutGuestAccountLoginLink_userExistsMetadata$key | null;
};

export const CheckoutGuestAccountLoginLink: FC<Props> = ({
    email,
    userExistsMetadata: userExistsMetadataRef,
}) => {
    const dispatch = useAppDispatch();

    const userExistsMetadata = useFragment(
        graphql`
            fragment CheckoutGuestAccountLoginLink_userExistsMetadata on UserExistsMetadataType {
                ...checkoutAuthActions_userExistsMetadata
            }
        `,
        userExistsMetadataRef
    );

    const onLogin = useCallback<MouseEventHandler>(
        event => {
            event.preventDefault();
            trackFormInteraction();
            openLoginModal({
                email,
                gaLabel: 'checkout - login faster',
                dispatch,
                userExistsMetadata,
            });
        },
        [dispatch, email, userExistsMetadata]
    );
    return (
        <div
            className={classNames(
                dibsCss.sassyFontBodySmall,
                dibsCss.bgBuyertertiary,
                dibsCss.pxXsmall,
                dibsCss.pyXxsmall,
                dibsCss.roundedXxsmall,
                dibsCss.inlineBlock
            )}
        >
            <FormattedMessage
                id="checkout.CheckoutGuestAccountLoginLink"
                defaultMessage="We found your account! <a>Log in</a> to checkout faster."
                values={{
                    a: content => <Link onClick={onLogin}>{content}</Link>,
                }}
            />
        </div>
    );
};
